import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  backerFinishes: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
